export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
  STAFF: 'staff'
};

export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: [
    'create_expense',
    'edit_expense',
    'delete_expense',
    'view_all_expenses',
    'manage_users',
    'manage_categories',
    'manage_staff_savings'
  ],
  [USER_ROLES.MANAGER]: [
    'create_expense',
    'edit_expense',
    'delete_expense',
    'view_all_expenses',
    'manage_categories'
  ],
  [USER_ROLES.USER]: [
    'create_expense',
    'edit_expense',
    'view_own_expenses'
  ],
  [USER_ROLES.STAFF]: [
    'view_own_savings',
    'view_profile',
    'edit_profile'
  ]
};

export const hasPermission = (userRole, permission) => {
  if (!userRole || !permission) return false;
  return ROLE_PERMISSIONS[userRole]?.includes(permission) || false;
}; 